
import React from "react";

const DealColumn = ({ title, color }) => {
  return (
    <div className="mb-4">
      <h6 className="mb-3">{title}</h6>

      <div className="row">
        {[1,2].map(i => (
          <div key={i} className="col-md-4 mb-3">
            <div className="card p-3 deal-card">
              <div className="border-top mb-2" style={{borderColor: color, borderWidth:2}}></div>

              <div className="fw-semibold">Website Redesign</div>

              <p className="small mt-2">
                💰 $25,000 <br/>
                📧 mail@mail.com <br/>
                📞 +123456789
              </p>

              <div className="d-flex justify-content-between small">
                <span>👤</span>
                <span>📞 ✉️</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Deals = () => {
  return (
    <div className="container mt-4">
      <style>{`
        .deal-card { box-shadow:0 6px 15px rgba(0,0,0,0.1); border-radius:10px; }
      `}</style>

      <h4>Deals</h4>

      <DealColumn title="New" color="purple" />
      <DealColumn title="Prospect" color="cyan" />
      <DealColumn title="Proposal" color="gold" />
    </div>
  );
};

export default Deals;